export const imageCodes = {
    oil: {
        code: "sarphosaung_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Foil.jpg?alt=media&token=f4dd1638-d285-415f-aa4c-9e2c62057c7f"
    },

    rice: {
        code: "sarphosaung_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frice%202.jpg?alt=media&token=7da60cf0-ec96-43c7-a50c-1c189d6b16b8"
    },

    sunoil: {
        code: "sarphosaung_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fsunoil.jpg?alt=media&token=e0d668db-d722-495f-8d10-b10834651a36"
    },
}

export const titleCodes = {
    
    aboutTitle: {
        code: "${merchantId}_tmpl_title_7",
        title: "စားဖိုဆောင်ရဲ့ ဦးတည်ရာ ..."
    },

    news: {
        code: "${merchantId}_tmpl_title_8",
        title: "Newsletter Corner"
    },

    news1: {
        code: "${merchantId}_tmpl_title_9",
        title: "အညာဒေသထွက် ပဲဆုံဆီစစ်စစ်"
    },

    news2: {
        code: "${merchantId}_tmpl_title_10",
        title: "ဆန်သစ် နဲ့ ဆန်ဟောင်း"
    },

    news3: {
        code: "${merchantId}_tmpl_title_11",
        title: "ဓာတုလွတ် သဘာဝဆီသန့်များ"
    },

}

export const textCodes = {

    about1: {
        code: "${merchantId}_tmpl_text_8",
        text: "စားဖိုဆောင်မှာ ဘာလို့ local product တွေကို အဓိကထားပြီး တင်ဖြစ်သလဲဆိုတော့ စိုက်ပျိုးထုတ်လုပ်သူတောင်သူကြီးတွေ၊ အိမ်တွင်းမှုလုပ်ငန်းတွေက သန့်ရှင်းလတ်ဆတ်ပြီး စံချိန်မီတဲ့ပစ္စည်းတွေကို စားသုံးသူ အိမ်သူအိမ်သားများဆီ တိုက်ရိုက်ပို့ဆောင်ပေးလိုတဲ့အတွက် ဖြစ်ပါတယ်"
    },

    about2: {
        code: "${merchantId}_tmpl_text_9",
        text: "ပစ္စည်းမှန် စျေးတန် အချိန်မှန် ဆိုတဲ့ စားဖိုဆောင်ရဲ့ ဆောင်ပုဒ်ကိုလည်း ထိန်းသိမ်းရင်း ကျန်းမာရေးနဲ့ညီညွတ်တဲ့ Kitchen Supply တွေ၊ ပိုကောင်းလာတဲ့ Service ပေးနေနိုင်ဖို့ ကြိုးစားလျက်ပါ။"
    },

    local1: {
        code: "${merchantId}_tmpl_text_10",
        text: "စားဖိုဆောင်ရဲ့ ရည်ရွယ်ချက်တစ်ခုကတော့ တောင်သူတွေနဲ့ စားသုံးသူတွေကြား ချိတ်ဆက်ရောင်းချပေးနိုင်ဖို့လည်း အဓိကဖြစ်ပါတယ်"
    },

    local2: {
        code: "${merchantId}_tmpl_text_11",
        text: "ဒါကြောင့် ကျောက်ပန်းတောင်းမြို့နယ်၊ ချောက်ဒေသဘက်ကထွက်တဲ့ 'မြေပဲဆုံဆီ' စစ်စစ်ကို တောင်သူတွေဆီကနေ တိုက်ရိုက်ယူရောင်းပေးနေပါတယ်။ အမြတ်အစွန်းအနေနဲ့ တင်ပို့ခသာသာလောက်ပဲ ယူထားတာမို့ လိုအပ်သလောက် မှာယူနိုင်ပါတယ်"
    },

    rice1: {
        code: "${merchantId}_tmpl_text_12",
        text: "စားဖိုဆောင်မှာတော့ ဆန်သစ်နဲ့ ဆန်ဟောင်းက သူ့အကြိုက်နဲ့သူ ဝယ်နေကြတာပါပဲ"
    },

    rice2: {
        code: "${merchantId}_tmpl_text_13",
        text: "• ဆန်သစ်က နည်းနည်းလေး စေးသေးတော့ ထမင်းစေးတာ မကြိုက်တဲ့သူဆိုရင်ကျတော့ ဆန်‌ဟောင်းပဲဝယ်တာပေါ့နော်။ ဒါပေမဲ့ သူကအဆီအနှစ်ပိုများ၊ စေးစေးမွှေးမွှေးလေးပေါ့။"
    },

    rice3: {
        code: "${merchantId}_tmpl_text_14",
        text: "• ဆန်ဟောင်းကတော့ နည်းနည်းဖွာလာပြီ။ စင်းကော့နေတုန်းပေမဲ့ ရေလည်းနည်းနည်းပိုထည့်လာရပြီ။ ဆန်ဟောင်းဝယ်ရင်တော့ လိုသလောက်ပဲဝယ်တာ ကောင်းတယ်။ အိမ်မှာကျ ပိုးမတက်အောင်ထားဖို့ ထိန်းရသိမ်းရတယ်လေ..။"
    },

    rice4: {
        code: "${merchantId}_tmpl_text_15",
        text: "စျေးကျတော့လည်း ၂၄ ပြည် တစ်အိတ်ကို ၁၆၀၀၀ ဝန်းကျင်လောက် ကွာပါတယ်။"
    },

    oil1: {
        code: "${merchantId}_tmpl_text_16",
        text: "• မြေပဲဆီသန့်"
    },

    oil2: {
        code: "${merchantId}_tmpl_text_17",
        text: "• နေကြာဆီသန့်"
    },

    oil3: {
        code: "${merchantId}_tmpl_text_18",
        text: "ကိုယ့်ရဲ့ ခန္ဓာကိုယ်ထဲကိုရောက်မယ့်အရာတွေကို အတတ်နိုင်ဆုံး ဓာတု‌ဗေဒဆေးတွေ လွတ်ကင်းတဲ့အရာကို ရွေးချယ်တာကလည်း မိမိကိုယ်ကိုယ် စောင့်ရှောက်ခြင်းတစ်မျိုးပါပဲနော်။"
    },
    
    oil4: {
        code: "${merchantId}_tmpl_text_19",
        text: "စားဖိုဆောင်တံဆိပ် သဘာဝဆီသန့်များကို မြေလတ်ဒေသဖြစ်တဲ့ မိတ္ထီလာရှိ ဆီစက်မှာ ကြိတ်ခွဲပြီး မြန်မာပြည်အနှံ့ တင်ပို့ရောင်းချပါတယ်"
    },

}